import { QuestionTypes } from "../actions/question";

const initialState = {
  loading: false,
  collection: []
};

const question = (state = initialState, { type, payload }) => {
  switch (type) {
    case QuestionTypes.GET_ALL_START:
    case QuestionTypes.GET_ALL_FAILURE:
      return { ...state, loading: false };

    case QuestionTypes.GET_ALL_SUCCESS:
      return {
        ...state,
        collection: payload.map((question, index) => ({
          ...question,
          questionNumber: index + 1
        }))
      };

    default:
      return state;
  }
};

export default question;



// WEBPACK FOOTER //
// ./src/reducers/question.js